import React, { useState, useEffect, useCallback } from "react";
import axios from '../../../../../api/apiClient';
import { token, domain } from "../../../../Security";
import { LoadingSpinner } from "../../../../../common/Loading";

import GroupIcon from "@mui/icons-material/Group";
import { LegendDetails } from "../fields/LegendTabFld/LegendDetails";
import { Select } from "../../../../../common/Select";

export function LegendTab({ performanceRatingsLegends, form, handleInputChange }) {
  const [legends, setLegends] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchLegends = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(`${domain}/api/PerformanceRatingLegendGroup/active`, {
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
      });

      setLegends(response.data);

    } catch (err) {
      console.error(err);
      setError('Failed to load performance rating legends');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { 
    fetchLegends(); 
  }, []);

  // Transform legends data for Select component - matching Vessel component pattern
  const transformLegendData = (data) => {
    return data.map(item => ({
      value: item.id,
      label: item.description, // Using description as label
      isActive: item.isActive
    }));
  };

  const legendOptions = transformLegendData(legends);
  const selectedLegend = legends.find(l => l.id === parseInt(form.performanceRatingsLegendId));

  if (loading) return <LoadingSpinner loading={true} message="Loading legends..." />;

  if (error && legends.length === 0) return (
    <div className="bg-red-50 border border-red-300 p-6 rounded-lg text-center">
      <div className="text-red-800 mb-2">⚠️ {error}</div>
      <button
        onClick={fetchLegends}
        className="rounded bg-red-600 px-4 py-2 text-white hover:bg-red-700"
      >
        Retry
      </button>
    </div>
  );

  return (
    <div className="space-y-6">
      <div className="rounded-lg border border-gray-300 bg-white px-4 shadow-sm">
        <div className="border-b border-gray-300 py-1">
          <h3 className="font-medium text-gray-700">Performance Ratings Legend</h3>
          <p className="text-xs text-gray-500 mt-1">
            Select a legend group to use for this performance appraisal
          </p>
        </div>

        <div className="pb-3 pt-3">
          {/* Reusable Select Component - Use transformed data */}
          <Select
            label="Select KPI Legend Group:"
            value={form.performanceRatingsLegendId || ""}
            onChange={(e) => handleInputChange('performanceRatingsLegendId', e.target.value ? parseInt(e.target.value) : "")}
            options={legendOptions}
            placeholder={legendOptions.length === 0 ? "No legends available" : "Select a legend group..."}
            isDisabled={legendOptions.length === 0}
          />

          {/* Selected Legend Details */}
          <LegendDetails legend={selectedLegend} />

          {!selectedLegend && legends.length > 0 && (
            <div className="mt-4 text-center py-8 text-gray-500">
              <GroupIcon className="mx-auto mb-3 text-4xl text-gray-300" />
              <p>No KPI Legend selected yet.</p>
              <p className="text-sm mt-1">Click "Select a legend group" to select KPI Legend Group.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}